// Team — verified GREEN G13–G18.
// In production this is fetched from cms.daksfirst.com/api/peoples?sort=order:asc
// This array is the offline fallback.

export const team = [
  { role: "Managing Partner",       name: "Sumit Kanthed",         link: "#" },
  { role: "Investor Relations",     name: "Kartik Krishnaswamy",   link: "#" },
  { role: "Client Solutions",       name: "Abhineet Rai",          link: "#" },
  { role: "Design and Operations",  name: "Alexander Tovey",       link: "#" },
  { role: "Investment Team",        name: "Amit Kanthed",          link: "#" },
  { role: "Finance and Operations", name: "Amoli Sanghvi",         link: "#" }
];
